<footer class="footer">
  <div class="container-fluid">
    {{year}} &copy; HotelCard.
  </div>
</footer>
